window.products = window.products || {};

products.RecentlyViewedProducts = (function () {
  function RecentlyViewedProducts(element) {
    this.container = document.querySelector(
      '[data-section-type="' + element + '"]'
    );

    this.container.parentNode.classList.add("hidden")

    if (!this.container) {
      return;
    }

    this.options = JSON.parse(
      this.container.getAttribute("data-section-settings")
    );

    if (this.options["productId"]) {
      this.saveCurrentProduct();
    }

    this.fetchProducts();
  }


  RecentlyViewedProducts.prototype.fetchProducts = function () {
    var _this = this;
    var queryString = this.getSearchQueryString();

    if (queryString === "") {
      return;
    }

    fetch(
      "/search?view=recently-viewed-product&type=product&q=".concat(
        queryString
      ),
      {
        credentials: "same-origin",
        method: "GET",
      }
    ).then(function (response) {
      response.text().then(function (content) {
        var blankDivElement = document.createElement("div");
        blankDivElement.innerHTML = content;

        _this.container.querySelector(".recently-viewed-product--container").innerHTML =
          blankDivElement.querySelector(
            '[data-section-type="recently-viewed-products"] .recently-viewed-product--container'
          ).innerHTML;
        _this.container.parentNode.classList.remove("hidden")

      });
    });
  };

  RecentlyViewedProducts.prototype.saveCurrentProduct = function () {
    /*
     * - Check if the current product already exists, and if it does not, add it at the start
     * - Then, we save the current product into the local storage, by keeping only the 8 most recent
     */
    var items = JSON.parse(
        sessionStorage.getItem("recentlyViewedProducts") || "[]"
      ),
      productId = this.options["productId"];

    if (!items.includes(productId)) {
      items.unshift(productId);
    }

    try {
      sessionStorage.setItem(
        "recentlyViewedProducts",
        JSON.stringify(items.slice(0, 8)) //keeping only the last 8 items in the session storage.
      );
    } catch (error) {}
  };

  RecentlyViewedProducts.prototype.getSearchQueryString = function () {
    var items = JSON.parse(
      sessionStorage.getItem("recentlyViewedProducts") || "[]"
    );

    if (items.includes(this.options["productId"])) {
      items.splice(items.indexOf(this.options["productId"]), 1);
    }

    return items
      .map(function (item) {
        return "id:" + item;
      })
      .join(" OR ");
  };

  return RecentlyViewedProducts;
})();

new products.RecentlyViewedProducts("recently-viewed-products");


